// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"8a4ef70a","642":"5d91fe2c","761":"5d91fe2c"}[chunkId] + ".chunk.css";
};